import { AuthPartialStoreState } from '../auth.reducer';

export const getIsAuthenticated = (state: AuthPartialStoreState) => state.auth.login.isAuthenticated;

export const getForcePasswordReset = (state: AuthPartialStoreState) => state.auth.login.forcePasswordReset;

export const getForceTermsAgreement = (state: AuthPartialStoreState) => state.auth.login.forceTermsAgreement;

export const getLoading = (state: AuthPartialStoreState) => state.auth.login.loading;

export const getError = (state: AuthPartialStoreState) => state.auth.login.error;

export const getAuthAccessToken = (state: AuthPartialStoreState) => state.auth.login.authAccessToken;

export const getVerificationCode = (state: AuthPartialStoreState) => state.auth.login.verificationCode;

export const getTermsModalVisible = (state: AuthPartialStoreState) => state.auth.login.termsModalVisible;
